/*
 * @Description: Currency slice for sales channel
 */
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { getCurrencyList } from 'src/request/salesChannel/multiCurrency';
import { EnumReducers } from 'src/store/constants';
import { CurrencyVO } from 'src/types/common/Currency';

const target = (state) => state[EnumReducers.salesChannelCurrencySelect];

export const fetchSalesChannelCurrencyList = createAsyncThunk(
  'fetchSalesChannelCurrencyList',
  async (data: { salesChannelUuid: string }) => {
    const { salesChannelUuid } = data;
    const response = await getCurrencyList(salesChannelUuid);
    return { response, salesChannelUuid };
  },
);

interface CurrencyState {
  salesChannelUuid: string | null;
  primaryCurrencyCode: string | null;
  currencyList: CurrencyVO[] | null;
}

const defaultState: CurrencyState = {
  salesChannelUuid: null,
  primaryCurrencyCode: null,
  currencyList: null,
};

const salesChannelCurrencySlice = createSlice({
  name: 'salesChannelCurrencySelect',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchSalesChannelCurrencyList.fulfilled,
      (state, action) => {
        const { response, salesChannelUuid } = action.payload;
        const listChanged =
          JSON.stringify(state.currencyList) !== JSON.stringify(response);
        if (listChanged || state.salesChannelUuid !== salesChannelUuid) {
          state.salesChannelUuid = salesChannelUuid;
          const primaryCurrency = (response.find((i) => i.primary) || {})
            .currencyCode;
          state.primaryCurrencyCode = primaryCurrency;
          state.currencyList = response;
        }
      },
    );
  },
});

// selectors
const currentSalesChannelUuid = () =>
  createSelector(
    (state: any) => target(state).salesChannelUuid,
    (salesChannelUuid) => salesChannelUuid,
  );

const currentPrimaryCurrencyCode = () =>
  createSelector(
    (state: any) => target(state).primaryCurrencyCode,
    (primaryCurrencyCode) => primaryCurrencyCode,
  );

const getCurrencyListSelector = () =>
  createSelector(
    (state: any) => target(state).currencyList,
    (currencyList) => currencyList,
  );

export {
  currentSalesChannelUuid,
  currentPrimaryCurrencyCode,
  getCurrencyListSelector,
};

export default salesChannelCurrencySlice.reducer;
